<template>
  <div>
      <!-- controls -->
      <div class="field is-horizontal">
        <div class="field-body">
            <div class="field">
              <label class="label">Date Range</label>
                <div class="control has-icons-left">
                    <input class="input"
                            type="text"
                            placeholder="Date From - To"
                            readonly
                            ref="date"
                            :disabled="loading">
                    <span class="icon is-small is-left">
                        <i class="fas fa-calendar-alt"></i>
                    </span>
                </div>
            </div>
            <div class="field">
              <label class="label">Clients</label>
                <div class="control is-expanded">
                    <div class="select is-multiple is-fullwidth">
                        <select v-model="selectedClients"
                                :disabled="loading"
                                multiple
                                size="10">
                            <option v-for="c in clients"
                                    :value="c" :key="c.id">{{c.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="label">Methods</label>
                <div class="control is-expanded">
                    <div class="select is-multiple is-fullwidth">
                        <select v-model="selectedMethod"
                                :disabled="loading"
                                multiple
                                size="10">
                            <option value="Explicit">Explicit</option>
                            <option value="Pin">Pin</option>
                            <option value="Cashback">Cashback</option>
                            <option value="PaymentSystem">PaymentSystem</option>
                            <option value="Bonus">Bonus</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div class="field">
        <button class="button is-primary" @click="handleDownloadClick">Download</button>
      </div>

  </div>
</template>

<script>
import flatpickr from "flatpickr";
import dt from "../../services/datetime.service";
import state from "../../state";
import statsService from "../../services/stats.service";
import statsClientsService from "../../services/statsClients.service";

export default {
  name: 'stats-profit-multiple',
  data () {
    return {
      loading: false,
      selectedClients: [],
      selectedMethod: ['Pin'],
      currency: undefined
    }
  },
  computed: {
    clients () {
      return state.clients.get();
    },
    currencies () {
      return state.currencies.get();
    }
  },
  methods: {
    getTimeFrom () {
      const from = dt.fixDate(this.$data.calendar.selectedDates[0]);
      return dt
        .local(from)
        .utc();
    },
    getTimeTo () {
      const to = dt.fixDate(this.$data.calendar.selectedDates[1]);
      return dt
        .local(to)
        .endOf("day")
        .utc();
    },
    async handleDownloadClick () {
      const res = await statsService.getClientsProfitStatsXslx(
        this.selectedClients.map(c => c.id),
        this.getTimeFrom().toISOString(),
        this.getTimeTo().toISOString(),
        this.selectedMethod);
      const filename = this.getFilename(res.headers['content-disposition']);
      this.download(filename, res.data, res.headers['content-type']);
    },
    getFilename (contentDisposition) {
      const parts = contentDisposition
        .split(';')
        .map(i => i.trim());
      const reg = /^filename="([^"]+)"$/
      for (var i = 0; i < parts.length; i++) {
        const match = parts[i].match(reg);
        if (!match) continue;
        return match[1]
      }
      return ''
    },
    download (filename, buffer, mimeType) {
      const blob = new Blob([buffer], {type: mimeType});
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      const clickHandler = () => {
        setTimeout(() => {
          URL.revokeObjectURL(url);
          a.removeEventListener('click', clickHandler);
        }, 150);
      }
      a.addEventListener('click', clickHandler, false);
      a.click();
    }
  },
  mounted () {
    let start = dt
      .local(new Date())
      .add(-6, "days")
      .format("YYYY-MM-DD");
    let end = dt
      .local(new Date())
      .format("YYYY-MM-DD");
    this.$data.calendar = flatpickr(this.$refs.date, {
        mode: "range",
        maxDate: "today",
        defaultDate: [start, end],
    });
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// front/src/components/stats/profit-multiple.vue